export default __webpack_public_path__ + "static/media/2a3facafb54fafde69b3d54b0c27c1d11576759440271.590235b8.webp";